import { single } from '../calculators/single'
import { averageTimeOnArticle } from '../queries/averageTimeOnArticle'

export const averageTimeOnArticleGauge = {
  calculate: single,
  queries: [averageTimeOnArticle],
  title: '$Average time on article',
}
